import { generatePath, useParams } from 'react-router-dom';

import { Card, CardHeader } from '@mui/material';

import { useNavigateAfterSubmit } from 'common/hooks';

import { LoadingIndicator } from 'commonComponents/LoadingIndicator';
import { PageContainer } from 'commonComponents/PageContainer';

import { updateLicenseFile, useLicense, useLicenseFile } from 'api/licenses';
import { CreateIcon } from 'icons/CreateIcon';
import { getNumberOfMacAddresses, PLATFORMS } from 'licenses/utils';
import { ROUTES } from 'routes/routes';

import { LicenseFileForm } from './LicenseFileForm';

export function EditLicenseFile() {
    const navigateAfterSubmit = useNavigateAfterSubmit();
    const { id: licenseFileId } = useParams<{ id: string }>();

    const { data: licenseFile, error: licenseFileError } = useLicenseFile(Number(licenseFileId));

    const { data: license, error: licenseError } = useLicense(licenseFile?.license, Boolean(licenseFile));

    if (licenseError || licenseFileError) {
        return null;
    }

    if (!license || !licenseFile) {
        return <LoadingIndicator />;
    }

    const initialValues = {
        ...licenseFile,
    };

    switch (licenseFile.hardwareBinding.type) {
        case 'Visia Legacy MAC Address':
        case 'MAC Address': {
            const numberOfMacAddresses = getNumberOfMacAddresses(license.configuration);
            for (let index = 0; index < numberOfMacAddresses; index++) {
                initialValues[`mac_address_${index}`] = licenseFile.hardwareIdentifiers[index];
            }
            break;
        }
        case 'System ID':
        case 'MBC System ID':
        case 'Inficrypt System Id': {
            initialValues['system_id'] = licenseFile.hardwareIdentifiers[0];
            break;
        }
        case 'SmartDR Legacy SiteID': {
            initialValues['site_id'] = licenseFile.hardwareIdentifiers[0];
            break;
        }
        default:
            break;
    }

    Object.entries(PLATFORMS).forEach(([k, _v]) => {
        initialValues[`platform_${k}`] = licenseFile.platforms.includes(k);
    });

    return (
        <PageContainer>
            <Card>
                <CardHeader
                    title={`Edit license file ${licenseFile.isExpired ? '[EXPIRED]' : ''}`}
                    slotProps={{
                        title: licenseFile.isExpired ? { color: 'error' } : {},
                    }}
                />
                <LicenseFileForm
                    cancelButtonRoute={generatePath(ROUTES.LICENSEFILE_DETAIL, { id: licenseFile.id.toString() })}
                    navigate={navigateAfterSubmit}
                    license={license}
                    submitButtonIconClass={CreateIcon}
                    submitButtonText="Submit"
                    submitApiCall={values => updateLicenseFile(licenseFile.id, values)}
                    {...{ initialValues }}
                />
            </Card>
        </PageContainer>
    );
}
